import { render, staticRenderFns } from "./MovementUpdate.vue?vue&type=template&id=678c4dac&scoped=true&"
import script from "./MovementUpdate.vue?vue&type=script&lang=js&"
export * from "./MovementUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MovementUpdate.vue?vue&type=style&index=0&id=678c4dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c4dac",
  null
  
)

export default component.exports